module.exports = __webpack_public_path__ + "static/peacemaker-small-8a732352a3f443e6db2bf630238cda78.webp";